<!--
 * @Descripttion: 
 * @version: 
 * @Author: lhl
 * @Date: 2021-01-12 10:52:08
 * @LastEditors: lhl
 * @LastEditTime: 2021-01-13 16:38:08
-->
<template>
  <div class="step-box" >
    <i class="background" :style="{width: (step/total).toFixed(4)*100 + '%'}"></i>
    <span>{{step}} of {{total}}</span>
  </div>
</template>

<script>
  export default {
    name: "BdoProgress",

    props: {

      step: {
        type: [String, Number],
        default: 1
      },

      total: {
        type: [String, Number],
        default: 12
      }
    },
  }
</script>

<style lang="scss" scoped>

  .step-box {
    position: relative;
    font-family: $font-family-Regular;
    width: 160px;
    height: 20px;
    line-height: 20px;
    background: #919191;
    border-radius: 14px;
    font-size: $font-12;
    color: $list-bg-color;
    letter-spacing: $letter-space-9;
    text-align: center;
    span{
      position: relative;
      z-index: 10;
    }
    .background {
      position: absolute;
      left: 0;
      top:0;
      height: 20px;
      background: #FDB913;
      border-radius: 14px;
      z-index: 1;
    }
  }
</style>